import { selectCreativeLibrary } from '../../demo/creativeSelectors'
import createFormJson from '../../demo/fixtures/create-form.json'
import taskDetailJson from '../../demo/fixtures/task-detail.json'
import { demoProducts, useDemoStore } from '../../demo/store'

interface ProductAnalysisFact {
  chips: string[]
}

interface AudienceFact {
  tier: string
  who: string
}

interface StrategyFact {
  name: string
  format: string
}

interface ProductProcessFixture {
  productAnalysis: ProductAnalysisFact[]
  audienceAnalysis: AudienceFact[]
  creativeStrategies: StrategyFact[][]
}

export interface ScrapeFacts {
  host: string
  path: string
  name: string
  spec: string
  price: string
  chips: string
  audiences: string
  strategies: string
  creatives: string
  url: string
}

const processByProduct = taskDetailJson.byProduct as unknown as Record<string, ProductProcessFixture>
const prices = createFormJson.listPriceByProduct as Record<string, string>

function pick<T>(items: T[], index: number): T {
  return items[((index % items.length) + items.length) % items.length]!
}

export function scrapeProduct(productId: string, sourceUrl?: string, variant = 0): ScrapeFacts {
  const product = demoProducts.find((item) => item.id === productId)
  const process = processByProduct[productId]
  if (!product || !process) throw new Error(`Missing process facts for product ${productId}`)

  const url = sourceUrl?.trim() || product.url
  let host = url
  let path = '/'
  try {
    const parsed = new URL(url)
    host = parsed.host
    path = parsed.pathname || '/'
  } catch {
    // Keep the user's input visible when it is not parseable as an absolute URL.
  }

  const analysis = pick(process.productAnalysis, variant)
  const strategies = pick(process.creativeStrategies, variant)
  const state = useDemoStore.getState()
  const library = selectCreativeLibrary(state.creatives, state.ads, state.campaigns, state.violations, state.risks, { productId })

  return {
    host,
    path,
    name: product.name,
    spec: product.spec,
    price: prices[productId] ?? '',
    chips: analysis.chips.join(' / '),
    audiences: process.audienceAnalysis.map((item) => `${item.tier} ${item.who}`).join(' · '),
    strategies: `出 ${strategies.length} 条方向：${strategies.map((item) => `${item.name}（${item.format}）`).join(' / ')}`,
    creatives: `已挑出 ${library.length} 条${product.name}素材${library[0] ? `，先投「${library[0].name}」` : ''}`,
    url,
  }
}

export function fillProcessTemplate(template: string, facts: ScrapeFacts): string {
  const replacements: Record<string, string> = { ...facts }
  return Object.entries(replacements).reduce((result, [key, value]) => result.replaceAll(`{${key}}`, value), template)
}
